import { AUTH } from '@dataTypes/authTypes';

export const convertUserType = (auth: AUTH) => {
  let result = '';
  switch (auth) {
    case AUTH.USER:
      result = '유저';
      break;
    case AUTH.MANAGER:
      result = '매니저';
      break;
    case AUTH.ADMIN:
      result = '관리자';
      break;
    default:
      break;
  }

  return result;
};
